import React from "react";

import SectionTitle from "../general/SectionTitle";
import SmartLink from "../general/SmartLink";

//"Here's an Idea..." box - the Greek Isles destination wedding package, with photos beside the lists
const GreekIsles = ({ title, subtitle, lead, summary, includedTitle, included, images, button }) => (
  <section className={"boxed-section tone-grey"}>
    <div className={"container"}>
      <div className={"gold-box greek-box"}>
        <SectionTitle subtitle={subtitle}>{title}</SectionTitle>
        <div className={"greek-grid"}>
          <div className={"greek-text"}>
            <p className={"greek-lead"}>{lead}</p>
            <ul className={"greek-list"}>
              {summary.map((item) => <li key={item}>{item}</li>)}
            </ul>
            <p className={"greek-list-title"}>{includedTitle}</p>
            <ul className={"greek-list"}>
              {included.map((item) => <li key={item}>{item}</li>)}
            </ul>
            <SmartLink
              path={button.path}
              href={button.href}
              className={"btn"}
            >
              {button.label}
            </SmartLink>
          </div>
          <div className={"greek-photos"}>
            {images.map((image) => (
              <img
                key={image.src}
                src={image.src}
                alt={image.alt}
                width={image.width}
                height={image.height}
                loading={"lazy"}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default GreekIsles;
